import { Autocomplete, Chip, TextField } from "@mui/material";
import React from "react";

export default function TagInput({ value = [], onChange }) {
  return (
    <Autocomplete
      multiple
      freeSolo
      fullWidth
      options={[]}
      value={value}
      onChange={(_event, newValue) => {
        if (onChange) {
          onChange(newValue);
        }
      }}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <div key={index} className="w-fit">
            <Chip
              variant="outlined"
              label={option}
              {...getTagProps({ index })}
              sx={{ background: "#D7B9DF", color: "#000", borderRadius: "8px" }}
            />
          </div>
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            style: { borderRadius: "8px" },
          }}
          placeholder="Search Tags"
        />
      )}
    />
  );
}
